<template>
    <div class="payment">
        <Button @click="topUp()">
            <img src="@/assets/images/money-send_2.svg" alt="">
            <span>{{text('payment.topup_btn')}}</span>
        </Button>   
        <button @click="$router.push({name: 'Exchange'})">
            <img src="@/assets/images/exchange-icon.svg" alt="">
            <span>{{text('payment.exchange_btn')}}</span>
        </button>             
        <Button @click="withdrawal()">
            <img src="@/assets/images/money-send.svg" alt="">
            <span>{{text('payment.withdrawal_btn')}}</span>
        </Button>
    </div>
</template>

<script>
import Button from '@/components/Button.vue'


export default {
    name: "Payment",
    computed: {
        authInfo () {
            return this.$store.state.authInfo
        },
        authToken () {
            return this.$store.state.authToken
        }
    },    
    methods: {
        withdrawal(){
            if (this.authInfo.is_withdrawal_allowed) {
                this.$router.push({name: "WalletWithdrawal"})
            } else {
                alert(this.text('payment.topup.not_avaliable'))
            }
        },
        topUp() {
            if (this.authInfo.is_topup_allowed) {
                this.$router.push({name: "WalletTopUp"})
            } else {
                alert(this.text('payment.withdrawal.not_avaliable'))
            }
        }
    }    
}
</script>

<style>

</style>